import type { CreateCheckoutResponse } from '../types';

function trackPaymentEvent(event: 'payment-started' | 'payment-completed') {
  if (typeof window === 'undefined') return;

  window.umami?.track(event);
  window.AhrefsAnalytics?.sendEvent(event);
}

export function trackPaymentStarted() {
  trackPaymentEvent('payment-started');
}

export function trackPaymentCompleted() {
  trackPaymentEvent('payment-completed');
}

export function resolveCheckoutClientSecret(
  result: CreateCheckoutResponse,
  onAlreadyPaid: () => void,
): string {
  if (result.alreadyPaid) {
    onAlreadyPaid();
    throw new Error('Already paid');
  }

  return result.clientSecret;
}
